export const timezoneName = {
  USA: {
    // 'GMT-3': 'Atlantic Time (AT)',
    // 'GMT-8': 'Alaska Time (AT)',
    // 'GMT-5': 'Central Time (CT)',
    // 'GMT-4': 'Eastern Time (ET)',
    // 'GMT-6': 'Mountain Time - Arizona (MT-AZ)',
    // 'GMT-7': 'Pacific Time (PT)',
    // 'GMT-10': 'Hawaii-Aleutian Standard Time',
  },
  Canada: {
    // 'GMT-2:30': 'Newfoundland Time (NT)',
    // 'GMT-3': 'Atlantic Time (AT)',
    // 'GMT-5': 'Central Time - Saskatchewan (CT-SK)',
    // 'GMT-4': 'Eastern Time (ET)',
    // 'GMT-6': 'Mountain Time (MT)',
    // 'GMT-7': 'Pacific Time (PT)',
  },
};

export const timezones = {
  USA: [
    // {
    //   value: 'Alaska Time (AT)',
    //   title: 'Alaska Time',
    //   code: 'AT',
    //   location: 'Anchorage',
    //   timezone: 'GMT-8',
    //   timezoneId: '1',
    // },
    // {
    //   value: 'Central Time (CT)',
    //   title: 'Central Time',
    //   code: 'CT',
    //   location: 'Houston, Chicago, New Orleans',
    //   timezone: 'GMT-5',
    //   timezoneId: '2',
    // },
    // {
    //   value: 'Eastern Time (ET)',
    //   title: 'Eastern Time',
    //   code: 'ET',
    //   location: 'New York, Boston, Miami, Atlanta',
    //   timezone: 'GMT-4',
    //   timezoneId: '3',
    // },
    // {
    //   value: 'Mountain Time (MT)',
    //   title: 'Mountain Time',
    //   code: 'MT',
    //   location: 'Salt Lake City, Denver',
    //   timezone: 'GMT-6',
    //   timezoneId: '4',
    // },
    // {
    //   value: 'Mountain Time - Arizona (MT-AZ-DLS)',
    //   title: 'Mountain Time - Arizona - DLS',
    //   code: 'MT-AZ-DLS',
    //   location: 'Phoenix',
    //   timezone: 'GMT-6',
    //   timezoneId: '5',
    // },
    // {
    //   value: 'Pacific Time (PT)',
    //   title: 'Pacific Time',
    //   code: 'PT',
    //   location: 'Los Angeles, Seattle, Las Vegas',
    //   timezone: 'GMT-7',
    //   timezoneId: '6',
    // },
    // {
    //   value: 'Hawaii-Aleutian Standard Time',
    //   title: 'Hawaii-Aleutian',
    //   code: 'HST',
    //   location: 'Andreanof Islands, Islands of Four Mountains, Near Islands, Rat Islands',
    //   timezone: 'GMT-10',
    //   timezoneId: '7',
    // },
    // {
    //   value: 'Atlantic Time (AT)',
    //   title: 'Atlantic Time',
    //   code: 'AT',
    //   location: 'Halifax, Fredericton, Charlottetown',
    //   timezone: 'GMT-3',
    //   timezoneId: '8',
    // },
    // {
    //   value: 'Mountain Time - Arizona (MT-AZ)',
    //   title: 'Mountain Time - Arizona',
    //   code: 'MT-AZ',
    //   location: 'Phoenix',
    //   timezone: 'GMT-7',
    //   timezoneId: '9',
    // },
  ],
  CANADA: [
    // {
    //   value: 'Atlantic Time (AT)',
    //   title: 'Atlantic Time',
    //   code: 'AT',
    //   location: 'Halifax, Fredericton, Charlottetown',
    //   timezone: 'GMT-3',
    //   timezoneId: '9',
    // },
    // {
    //   value: 'Central Time (CT)',
    //   title: 'Central Time',
    //   code: 'CT',
    //   location: 'Winnipeg',
    //   timezone: 'GMT-5',
    //   timezoneId: '10',
    // },
    // {
    //   value: 'Central Time - Saskatchewan (CT-SK)',
    //   title: 'Central Time - Saskatchewan',
    //   code: 'CT-SK',
    //   location: 'Saskatoon, Regina',
    //   timezone: 'GMT-5',
    //   timezoneId: '11',
    // },
    // {
    //   value: 'Eastern Time (ET)',
    //   title: 'Eastern Time',
    //   code: 'ET',
    //   location: 'Toronto, Montreal, Ottawa',
    //   timezone: 'GMT-4',
    //   timezoneId: '12',
    // },
    // {
    //   value: 'Mountain Time (MT)',
    //   title: 'Mountain Time',
    //   code: 'MT',
    //   location: 'Calgary, Edmonton, Yellowknife',
    //   timezone: 'GMT-6',
    //   timezoneId: '13',
    // },
    // {
    //   value: 'Newfoundland Time (NT)',
    //   title: 'Newfoundland Time',
    //   code: 'NT',
    //   location: "St. John's",
    //   timezone: 'GMT-2:30',
    //   timezoneId: '14',
    // },
    // {
    //   value: 'Pacific Time (PT)',
    //   title: 'Pacific Time',
    //   code: 'PT',
    //   location: 'Vancouver, Victoria',
    //   timezone: 'GMT-7',
    //   timezoneId: '15',
    // },
  ],
};
